import { inject } from '@angular/core'
import { provideAppInitializer } from '@angular/core'
import { Auth } from '@angular/fire/auth'

import { onAuthStateChanged } from 'firebase/auth'

import { AUTH_SERVICE } from '../tokens/auth-service.token'
import { AUTH_STORE } from '../tokens/auth-store.token'
import { ENVIRONMENT } from '../tokens/environment.token'

/**
 * Provides an application initializer for authentication setup.
 *
 * This function sets up the authentication process by injecting the necessary
 * dependencies (`Auth` and `AuthStore`), configuring the tenant ID, and
 * listening for authentication state changes. Once the authentication state
 * is determined, it resolves the initialization process.
 *
 * @returns A function that initializes the authentication process and returns
 * a promise that resolves once the authentication state is set.
 */
export const provideAuthInitializer = () => {
  return provideAppInitializer(() => {
    const auth = inject(Auth)
    const authService = inject(AUTH_SERVICE)
    const authStore = inject(AUTH_STORE)
    const env = inject(ENVIRONMENT)

    auth.tenantId = env.tenantId

    return new Promise<void>((resolve) => {
      onAuthStateChanged(auth, (firebaseUser) => {
        if (firebaseUser && !authStore.getIsLoggingIn()) {
          authService.loginToYoshuApi(firebaseUser).subscribe(() => resolve())
        } else {
          resolve()
        }
      })
    })
  })
}
